// Delicate vector constellations for the 12 zodiac signs.
// Points are in a 0-100 viewBox; connections are index pairs.

const C = {
  Aries: { pts: [[20, 70], [40, 55], [62, 48], [80, 40]], links: [[0, 1], [1, 2], [2, 3]] },
  Taurus: { pts: [[25, 35], [42, 48], [55, 60], [70, 52], [82, 40], [38, 70]], links: [[0, 1], [1, 2], [2, 3], [3, 4], [2, 5]] },
  Gemini: { pts: [[30, 20], [34, 50], [38, 80], [62, 22], [66, 52], [70, 82]], links: [[0, 1], [1, 2], [3, 4], [4, 5], [0, 3], [2, 5]] },
  Cancer: { pts: [[25, 40], [45, 55], [60, 45], [78, 60], [45, 78]], links: [[0, 1], [1, 2], [2, 3], [1, 4]] },
  Leo: { pts: [[20, 60], [34, 45], [50, 40], [66, 48], [78, 62], [70, 80], [40, 72]], links: [[0, 1], [1, 2], [2, 3], [3, 4], [4, 5], [5, 6], [6, 0]] },
  Virgo: { pts: [[18, 45], [38, 52], [55, 46], [72, 55], [50, 68], [60, 32]], links: [[0, 1], [1, 2], [2, 3], [1, 4], [2, 5]] },
  Libra: { pts: [[25, 65], [40, 42], [60, 42], [75, 65], [50, 32]], links: [[0, 1], [1, 4], [4, 2], [2, 3], [1, 2]] },
  Scorpio: { pts: [[18, 35], [34, 45], [50, 50], [64, 58], [76, 70], [84, 55]], links: [[0, 1], [1, 2], [2, 3], [3, 4], [4, 5]] },
  Sagittarius: { pts: [[22, 70], [42, 55], [58, 48], [76, 38], [60, 68], [50, 30]], links: [[0, 1], [1, 2], [2, 3], [2, 4], [2, 5]] },
  Capricorn: { pts: [[20, 50], [40, 38], [58, 46], [74, 62], [48, 70]], links: [[0, 1], [1, 2], [2, 3], [3, 4], [4, 0]] },
  Aquarius: { pts: [[20, 45], [34, 58], [48, 46], [62, 58], [76, 46]], links: [[0, 1], [1, 2], [2, 3], [3, 4]] },
  Pisces: { pts: [[20, 40], [36, 52], [52, 46], [68, 58], [82, 48], [52, 30]], links: [[0, 1], [1, 2], [2, 3], [3, 4], [2, 5]] },
};

export default function Constellation({ sign, size = 160, className = "" }) {
  const data = C[sign] || C.Aries;
  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      className={className}
      aria-label={`${sign} constellation`}
    >
      {data.links.map(([a, b], i) => {
        const [x1, y1] = data.pts[a];
        const [x2, y2] = data.pts[b];
        return (
          <line
            key={i}
            x1={x1}
            y1={y1}
            x2={x2}
            y2={y2}
            stroke="#D4AF37"
            strokeWidth="0.6"
            strokeOpacity="0.5"
            className="pulse-line"
            style={{ animationDelay: `${i * 0.3}s` }}
          />
        );
      })}
      {data.pts.map(([x, y], i) => (
        <g key={i}>
          <circle cx={x} cy={y} r="2.6" fill="#F3E5AB" opacity="0.18" />
          <circle cx={x} cy={y} r="1.3" fill="#F3E5AB" className="twinkle" style={{ animationDelay: `${i * 0.4}s` }} />
        </g>
      ))}
    </svg>
  );
}
